var _style, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTmInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;}\r\n\t.st1{fill:#678134;}\r\n\t.st2{fill:#1B7D9F;}\r\n\t.st3{fill:#934D4F;}\r\n\t.st4{fill:#FFFFFF;}\r\n\t.st5{fill:#8B7734;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Outline"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 16,
    height: 16
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Color"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 8,
    cy: 4.28,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M8.954,7.24v5.11c0,0.24-0.2,0.43-0.44,0.43H7.486c-0.24,0-0.44-0.19-0.44-0.43V7.24 C7.056,7,7.246,6.8,7.486,6.8h1.029C8.754,6.8,8.954,7,8.954,7.24z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "White"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55779",
    className: "st4",
    d: "M8,0C3.58,0,0,3.58,0,8c0,4.42,3.58,8,8,8s8-3.58,8-8C15.99,3.58,12.42,0.01,8,0z M8.95,12.35 c0,0.24-0.2,0.43-0.44,0.43H7.49c-0.24,0-0.44-0.19-0.44-0.43V7.24C7.06,7,7.25,6.8,7.49,6.8h1.02c0.24,0,0.44,0.2,0.44,0.44V12.35 z M8,5.48c-0.66,0-1.2-0.53-1.2-1.2c0-0.66,0.54-1.2,1.2-1.2s1.2,0.54,1.2,1.2C9.2,4.95,8.66,5.48,8,5.48z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTmInfo);
export default __webpack_public_path__ + "static/media/TM_Info.a2b881f1d0ef3ab3f564f37cfda87a61.svg";
export { ForwardRef as ReactComponent };